import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Problema from '../../../../assets/images/qualificacao.webp';
import Foto1 from '../../../../assets/images/config-router2.png';

import * as AiIcons from "react-icons/ai";
import * as BiIcons from "react-icons/bi";
import * as FcIcons from "react-icons/fc";
import * as MdIcons from "react-icons/md";

import IoT from './Solucao/Solucao';
import Conexoes from './Analise/Analise';
import Config from './Negligencia/Negligencia';

import 'bootstrap/dist/css/bootstrap.min.css';
import Analise from './Analise/Analise';
import Negligencia from './Negligencia/Negligencia';
import Solucao from './Solucao/Solucao';


function Qualificacao() {
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Popover Information</Popover.Header>
      <Popover.Body>
        Here is some <strong>interesting</strong> information about connected devices and their impact on Wi-Fi networks.
      </Popover.Body>
    </Popover>
  );

  const PopoverButton = () => (
    <OverlayTrigger trigger="click" placement="right" overlay={popover}>
      <Button variant="outline-primary" style={{ padding: '0 5px', margin: '0 5px', fontSize: 'inherit' }}>dispositivos conectados </Button>
    </OverlayTrigger>
  );

  const [activeTab, setActiveTab] = useState('/analise');

  const handleTabSelect = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            <h1>Qualificação profissional</h1>
            <img src={Problema} alt='problema' className='img-fluid mb-0' />

            <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
              <Nav fill variant="tabs" defaultActiveKey="/analise">
                <Nav.Item>
                  <Nav.Link eventKey="/analise">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>Análise do ambiente</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="/negligencia">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>Negligência</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="/solucao">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>Solução de problemas</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content className='container'>
                    <Tab.Pane eventKey="/analise">
                        <Analise />
                    </Tab.Pane>                     
                    <Tab.Pane eventKey="/negligencia">
                        <Negligencia />
                    </Tab.Pane> 
                    <Tab.Pane eventKey="/solucao">
                        <Solucao />
                    </Tab.Pane>                     
                </Tab.Content>
            </Tab.Container>           
          </div>
          <div className='col-sm-12 col-md-6'>
            <div className='imagem'>
              <img className="d-block w-100" src={Foto1} alt="First slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Qualificacao;
